//@vendor
const moment = require('moment');
const get = require('lodash/object/get');
const download = require('downloadjs');
const { createActions } = require('redux-actions');
//@constants
const {
    amortizationTypes,
    payrollLoanCommon,
    retailLoanCommons,
    DEFAULT_BEFORE_STEP,
    contractEasyLoan: { PAYMENT_DAY_END_OF_MONTH },
    VERSION_2,
    LOANS_INDEX_POSTAL_CODE,
    retailLoanDoTaggin: {
        FORMALIZE_ERROR,
        TAGGING_NEXT,
        TAGGING_CHECKOUT,
        TAGGING_PURCHASE,
        TAGGING_ACCEPT,
    },
    RETAIL_LOAN_CONSENTS_STATUS,
    RETAIL_LOAN_PLACEMENT_ID,
    RETAIL_LOAN_CONSENTS_ID,
    retailLoanCommons: { STORE_PICKUP, ADDRESS_DELIVERY, RETAIL_LOAN_PRECONTRACTUAL, NEW_RETAIL_LOAN_PRECONTRACTUAL, NEW_RETAIL_LOAN_CONTRACT },
} = require('../loansConstants/index');
const { EURO_TEXT, WIZARD_FIRST_STEP, WIZARD_FOURTH_STEP, WIZARD_THIRD_STEP, DATE_FORMAT_API, COMMERCIAL_ADS_CHANNEL } = require('constants/index');
const { es: { DATE_FORMAT_WITH_SLASHES } } = require('commonsConstants/dateFormatTypes');
const translationContractLoanPdfViewerINE = require('../components/contracts/contractLoanPdfViewerINE/contractLoanPdfViewerINE.translations');
const {
    PRE_CONTRACTUAL_RETAIL_LOAN_MAIL,
    RETAIL_LOAN_LEGAL_CHECK,
    NOT_ALLOWED_NEW_RETAIL_LOAN_FLOW_COUNTRIES,

} = require('constants/flagBasedFeatures');
const { COUNTRY_CODE_ES } = require('commonsConstants/countryCodes')
//@utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const { parseSpanishNumberToFloat, formatNumber, formatAmount } = require('utilities/currencyHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { formattedPhone } = require('utilities/personalDataHelper');
const BrowserUtils = require('utilities/browserUtils');
const {
    recordLinkV2,
} = require('utilities/tagging');
const {
    PROC_FAIL,
    PROC_END,
    PROC_CONTRACT_RETAIL_LOAN,
    recordProcess,
} = require('utilities/tagging');
const {
    isRetailAddressDelivery,
    buildEventsWizardRetailLoan,
    buildFormalizeRetailLoanProcess,
    buildEventsModalInterstitial,
    getFilteredAccountIndexes
} = require('../loansUtilities/loansHelper');
//@actions
const { validateAndExecute } = require('actions/signaturePattern');
//@helpers
const {
    downLoadDocumentInOtherPage,
} = require('../loansUtilities/loansHelper');
// @core
const { formatText, getLanguage } = require('core/i18n').i18n;

const simpleActions = createActions(
    'RETAIL_LOAN_ASNEF',
    'RETAIL_LOAN_ASNEF_ERROR',
    'RETAIL_LOAN_ASNEF_FAILURE',
    'RETAIL_LOAN_ASNEF_SUCCESS',

    'RETAIL_LOAN_CHANGE_EMAIL',
    'RETAIL_LOAN_CHANGE_BILLING-ADDRESS',
    'RETAIL_LOAN_CHANGE_DELIVERY_ADDRESS_VALUE',

    'RETAIL_LOAN_CONSENTS',
    'RETAIL_LOAN_CONSENTS_SUCCESS',
    'RETAIL_LOAN_AMAZON_CONSENTS_SUCCESS',
    'RETAIL_LOAN_CONSENTS_ERROR',

    'RETAIL_LOAN_DESTINATION_ACCOUNT',
    'RETAIL_LOAN_DESTINATION_ACCOUNT_ERROR',
    'RETAIL_LOAN_DESTINATION_ACCOUNT_SUCCESS',

    'RETAIL_LOAN_DOWNLOAD_PRINT_DOCUMENT',
    'RETAIL_LOAN_DOWNLOAD_PRINT_DOCUMENT_ERROR',
    'RETAIL_LOAN_DOWNLOAD_PRINT_DOCUMENT_SUCCESS',

    'RETAIL_LOAN_DOWNLOAD_ZIP_DOCUMENT',
    'RETAIL_LOAN_DOWNLOAD_ZIP_DOCUMENT_ERROR',
    'RETAIL_LOAN_DOWNLOAD_ZIP_DOCUMENT_SUCCESS',

    'RETAIL_LOAN_FORMALIZE',
    'RETAIL_LOAN_FORMALIZE_ERROR',
    'RETAIL_LOAN_FORMALIZE_SUCCESS',

    'RETAIL_LOAN_GET_TAE',
    'RETAIL_LOAN_GET_TAE_ERROR',
    'RETAIL_LOAN_GET_TAE_SUCCESS',

    'RETAIL_LOAN_GET_TOTAL_IMPORT',
    'RETAIL_LOAN_GET_TOTAL_IMPORT_ERROR',
    'RETAIL_LOAN_GET_TOTAL_IMPORT_SUCCESS',

    'RETAIL_LOAN_HIRING_DOCUMENTS',
    'RETAIL_LOAN_HIRING_DOCUMENTS_ERROR',
    'RETAIL_LOAN_HIRING_DOCUMENTS_SUCCESS',

    'RETAIL_LOAN_NOT_AVAILABLE',

    'RETAIL_LOAN_PRODUCTS',

    'RETAIL_LOAN_COMMERCIAL_PRODUCTS_SUCCESS',
    
    'RETAIL_LOAN_PRODUCTS_ERROR',
    'RETAIL_LOAN_PRODUCTS_SUCCESS',

    'RETAIL_LOAN_PROPOSITION_INFO',
    'RETAIL_LOAN_PROPOSITION_INFO_ERROR',
    'RETAIL_LOAN_PROPOSITION_INFO_SUCCESS',

    'RETAIL_LOAN_RESET_AGREE_THIRD_STEP',
    'RETAIL_LOAN_RESET_DOCUMENT_AND_AGREE_CHECKBOX',
    'RETAIL_LOAN_RESET_CATALOG_ITEM',
    'RETAIL_LOAN_RESET_PURPOSE',
    'RETAIL_LOAN_RESET_STATE',
    'RETAIL_LOAN_RESET_AGREE_CHECKBOX_MODAL',
    'RETAIL_LOAN_RESET_ERRORS_STATUS',
    'RETAIL_LOAN_SEND_PRECONTRACTUAL_INFO_FAILURE',
    'RETAIL_LOAN_SEND_PRECONTRACTUAL_INFO_SUCCESS',
    'RETAIL_LOAN_SEND_PRECONTRACTUAL_INFO_REQUEST',

    'RETAIL_LOAN_SET_ACCOUNT',
    'RETAIL_LOAN_SET_ACCOUNTS_INACTIVE',
    'RETAIL_LOAN_SET_AGREE',
    'RETAIL_LOAN_SET_INTERSTITIAL_CHECK',
    'RETAIL_LOAN_SET_AGREE_THIRD_STEP',
    'RETAIL_LOAN_SET_CATALOG_ITEM_ID',
    'RETAIL_LOAN_SET_DEDICATION',
    'RETAIL_LOAN_SET_DELIVERY_DATE',
    'RETAIL_LOAN_SET_GIFT',
    'RETAIL_LOAN_SET_INSTRUCTIONS',
    'RETAIL_LOAN_SET_PICKUP',
    'RETAIL_LOAN_SET_PURPOSE',
    'RETAIL_LOAN_SET_SHOW_PRODUCT',
    'RETAIL_LOAN_SET_TERM',
    'RETAIL_LOAN_SET_VISIBLE_STEP',

    'RETAIL_LOAN_TERM_CONDITION',
    'RETAIL_LOAN_TERM_CONDITION_ERROR',
    'RETAIL_LOAN_TERM_CONDITION_SUCCESS',

    'RETAIL_LOAN_CONSENT_UPDATE',
    'RETAIL_LOAN_CONSENT_UPDATE_ERROR',
    'RETAIL_LOAN_CONSENT_UPDATE_SUCCESS',

    'RETAIL_LOAN_UPDATE_PERSONAL_DATA',

    'RETAIL_LOAN_VALIDATE_AGREE_CHECKBOX',
    'RETAIL_LOAN_VALIDATE_AGREE_CHECKBOX_MODAL',
    'RETAIL_LOAN_VALIDATE_STEP',
    'CONTRACT_RETAIL_LOAN_INIT_SUCCESS',
    'CONTRACT_RETAIL_LOAN_INIT_ERROR',
    'CONTRACT_RETAIL_LOAN_INIT_POLICY_SUCCESS',
    'GET_RETAIL_LOAN_INE_DOCUMENT_SUCCESS',
    'GET_RETAIL_LOAN_INE_DOCUMENT_ERROR',
    'GET_RETAIL_LOAN_POLICY_DOCUMENT_SUCCESS',
    'GET_RETAIL_LOAN_POLICY_DOCUMENT_ERROR',
    'CONTRACT_RETAIL_LOAN_READ_DOCUMENT',
    'CONTRACT_RETAIL_LOAN_CHECK_BOX_CHECKED_DOCUMENT',
    'CONTRACT_RETAIL_EMAIL_SUCCESS',
    'CONTRACT_RETAIL_EMAIL_ERROR',

);

const getTotalImport = amount => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const arrangementPercentage = immRetailLoan.get('arrangementPercentage');
    const loanValue = parseInt(immRetailLoan.get('selectedAmount'));
    const setPickedAmount = loanValue > 0 ? loanValue : amount;

    dispatch(simpleActions.retailLoanGetTotalImport());
    const params = {
        query: {
            comisionApertura: arrangementPercentage,
            comisionAperturaMin: arrangementPercentage,
            valorPrestamo: setPickedAmount,
            cuota: immRetailLoan.getIn(['installment', 'amount']),
            numeroPagos: parseInt(immRetailLoan.get('selectedTerm')),
            finDeMes: immRetailLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH,// Anniversary date,
            tin: immRetailLoan.get('tin')
        }
    };

    return APIGet({ dispatch, endpoint: 'requestEasyLoanContractTotalAmount', params })
        .then(response => {
            dispatch(simpleActions.retailLoanGetTotalImportSuccess({ totalAmount: response.totalAmount }));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.retailLoanGetTotalImportError({ error: response.error }));
            } else {
                throw response;
            }
        });
}

const getItem = (immRetailLoan) => {
    const selectedId = immRetailLoan.get('purpose');
    const immProducts = immRetailLoan.get('products');
    return immProducts.find(immItem => selectedId === immItem.get('nid'));
};

const getTae = amount => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const immSegmented = immRetailLoan.getIn(['segmented', 'informacion'], {});
    const immSelectedItem = getItem(immRetailLoan);

    const params = {
        query: {
            indCapson: 'N',
            indIntccp: 'N',
            divisa: EURO_TEXT,
            importe: immSelectedItem.get('field_total_product_price'),
            indicaPrecios: 'E',
            plazo: immRetailLoan.get('selectedTerm'),
            tipodeproducto: immSegmented.get('tipo'),
            subtipodeproducto: immSegmented.get('subtipoPagoAniversario'),
            codigodeestandar: immSegmented.get('erPagoAniversario'),
            comisionApertura: parseInt(immSegmented.get('comisionApertura'))
        }
    };

    dispatch(simpleActions.retailLoanGetTae());
    return APIGet({ dispatch, endpoint: 'contractEasyLoanInstallments', params })
        .then(response => {
            dispatch(simpleActions.retailLoanGetTaeSuccess({
                tae: response.tae,
                indCapson: response.indCapson,
                installment: get(response, 'importePriCuota.importe')
            }))
            dispatch(getTotalImport(amount))
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.retailLoanGetTaeError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const setTerm = (selectedTerm, amount) => dispatch => {
    dispatch(simpleActions.retailLoanSetTerm({ selectedTerm }));
    dispatch(getTae(amount));
};

const getInfoProducts = (loan) => (dispatch, getState) => {
    const catalogIsLoad = getState().contractRetailLoan.get('catalogIsLoaded');
    const isRetailEnabled = getState().flagBasedFeatures.get('loan-retail-enabled', false);

    if (!catalogIsLoad && isRetailEnabled) {
        const language = getLanguage().toUpperCase() === COUNTRY_CODE_ES ? null : getLanguage();
        let requestData = {
            header: {
                version: VERSION_2
            },
            query: {
                maxAmount: parseFloat(get(loan, 'informacion.importeMaximo', 0)),
            }
        }

        if (!!language) {
            requestData.query = { ...requestData.query, language }
        }


        dispatch(simpleActions.retailLoanProducts());
        APIGet({ dispatch, endpoint: 'retailLoanGetProducts', params: requestData })
            .then(catalog => dispatch(simpleActions.retailLoanProductsSuccess({ segmented: loan, catalog })))
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.retailLoanProductsError({ error: response.error }));
                } else {
                    throw response;
                }
            });

    }
};

const buildAddressData = (immData) => {
    return {
        floor: 0,
        ladder: immData.get('restOfAddress'),
        letter: immData.get('restOfAddress'),
        locality: immData.get('locality'),
        portal: immData.get('restOfAddress'),
        postalCode: immData.get('postalCode'),
        province: immData.get('province'),
        streeNumber: immData.get('numberStreet'),
        streetName: immData.get('streetName'),
        streetType: immData.get('typeOfRoads'),
    };
}

const buildDeliveryAddress = selectedPickup => {
    const pickupAddress = selectedPickup.get('pickup_place_address');
    return {
        ladder: pickupAddress.get('road_additional_info'),
        locality: pickupAddress.get('road_locality'),
        postalCode: pickupAddress.get('road_postal_code'),
        province: pickupAddress.get('road_postal_code').slice(0, LOANS_INDEX_POSTAL_CODE),
        streeNumber: pickupAddress.get('road_number'),
        streetName: pickupAddress.get('road_name'),
        streetType: pickupAddress.get('road_type'),
        shopName: selectedPickup.get('pickup_place_name'),
    };
}
const checkReadDocument = (checked) => (dispatch, getState) => {
    dispatch(simpleActions.contractRetailLoanReadDocument(checked));

}
const checkCheckedDocument = (checked) => (dispatch, getState) => {
    dispatch(simpleActions.contractRetailLoanCheckBoxCheckedDocument(checked));

}
const formalizeQuery = (dataToken) => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const immAccounts = getState().accounts.get('byId');
    const immSegmented = immRetailLoan.getIn(['segmented', 'informacion'], {});
    const immAccount = immAccounts.get(immRetailLoan.get('selectedAccount'));

    const immPersonalData = immRetailLoan.get('personalData');
    const firstAddressIsSelected = immPersonalData.get('isSelected');
    let deliveryAddress;
    if (firstAddressIsSelected) {
        deliveryAddress = buildAddressData(immPersonalData);
    } else {
        const immOtherAddress = immRetailLoan.get('otherAddress');
        deliveryAddress = buildAddressData(immOtherAddress);
    }

    const immProfile = getState().profile;
    const email = PersonalDataHelper.getEmail(immProfile);
    const newEmail = immRetailLoan.get('newEmail');
    const code = immProfile.getIn(['telefonoContacto', 'codigoPais']);
    const number = immProfile.getIn(['telefonoContacto', 'numero']);

    const selectedItemId = immRetailLoan.get('purpose');
    const immProducts = immRetailLoan.get('products');
    const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));
    const productPrice = immSelectedItem.get('field_total_product_price');
    const immProposition = immRetailLoan.get('proposition');
    const propositionNumber = immProposition.get('propositionNumber');
    const propositionYear = immProposition.get('propositionYear');
    const openingCommission = formatAmount(immSegmented.get('comisionApertura'), 'es', 2);
    const deliveryType = immSelectedItem.get('field_pickup_option');
    const isDeliveryType = isRetailAddressDelivery(deliveryType);
    const selectedPickup = immRetailLoan.get('selectedPickup');

    let billingAddress;
    if (selectedPickup) {
        billingAddress = buildDeliveryAddress(selectedPickup);
    } else if (!immRetailLoan.get('otherBillingAddressIsSelected')) {
        const immBillingAddress = immRetailLoan.get('billingAddress');
        billingAddress = buildAddressData(immBillingAddress);
    } else {
        billingAddress = deliveryAddress;
    }

    const params = {
        query: {
            dataToken,
            amount: productPrice,
            accountContractNumber: immAccount.get('newContractNumber'),
            accountProduct: immAccount.get('newProduct'),
            currency: immRetailLoan.get('currency'),
            ibanCode: immAccount.getIn(["ibanComplex", "codbban"]),
            ibanCodeCountry: immAccount.getIn(["ibanComplex", "pais"]),
            ibanCodeDigit: immAccount.getIn(["ibanComplex", "digitodecontrol"]),
            loanContractNumber: immProposition.get('contractNumber'),
            loanProductNumber: immProposition.get('productNumber'),
            loanProductDescription: immSegmented.get('descTipoProducto'),
            propositionNumber: `${propositionNumber}`,
            year: propositionYear,
            endOfMonthDate: "N",
            openingCommission: openingCommission ? openingCommission : 0,
            registerDate: moment().startOf('day').format(DATE_FORMAT_API),
            dueDate: immProposition.get('loanDueDate'),
            purpose: immSelectedItem.get('title'),
            idInitialPic: immSegmented.get('idFotoInicial'),
            pickupOption: isDeliveryType ? ADDRESS_DELIVERY : STORE_PICKUP,
            dataRecord: {
                billingAddress,
                customer: {
                    email: newEmail !== '' ? newEmail : email,
                    mobilePhone: formattedPhone(code, number),
                    name: immProfile.get('nombreCliente'),
                    secondSurname: immProfile.getIn(['apellidoDos', 'apellido']),
                    surname: immProfile.getIn(['apellidoUno', 'apellido'])
                },
                deliveryAddress,
                product: {
                    productId: immSelectedItem.get('id'),
                    productName: immSelectedItem.get('title')
                },
                record: {
                    dedicatory: immRetailLoan.get('dedicationMessage'),
                    deliveryDate: immRetailLoan.get('deliveryDate'),
                    deliveryObservations: immRetailLoan.get('shippingInstructions'),
                    installment: immRetailLoan.getIn(['installment', 'amount']),
                    isAGift: immRetailLoan.get('giftOption') === retailLoanCommons.YES,
                    price: productPrice,
                    tae: formatAmount(immRetailLoan.get('tae'), 2),
                    term: immRetailLoan.get('selectedTerm'),
                    tin: immRetailLoan.get('tin')
                },
                provider: {
                    id: immSelectedItem.getIn(['field_retail_provider', 'abbreviation']),
                    name: immSelectedItem.getIn(['field_retail_provider', 'provider'])
                }
            },
            termsAndConds: {},
        }
    };

    if (immFlagBasedFeatures.get(RETAIL_LOAN_LEGAL_CHECK)) {
        const acceptedTextSplit = formatText('contractRetailLoanStepThree-contractRetailLoanStepThree_contractRetailLoanAgreeCheckboxLabel').split('%s');
        const injectedLinks = [
            formatText('contractRetailLoanStepThree-contractRetailLoanStepThree_contractRetailLoanIneDocument'),
            formatText('contractRetailLoanStepThree-contractRetailLoanStepThree_contractRetailLoanContractDocument')
        ];

        let acceptedText = '';
        acceptedTextSplit.map((message, index) => {
            const text = injectedLinks[index];
            const textValue = text ? text : '';
            acceptedText += message + textValue;
        });

        const termsAndConds = {
            acceptedText,
            dateTimeToSave: immRetailLoan.get('timesTampCheckBox'),
        }
        params.query.termsAndConds = termsAndConds;
    }
    if (immFlagBasedFeatures.get(NOT_ALLOWED_NEW_RETAIL_LOAN_FLOW_COUNTRIES)) {
        const acceptedText = formatText('contractRetailLoanStepFour-contractTitle');
        const operationProcessId = immRetailLoan.get('retailInitPolicyOperationProcessId')
        const documentId = immRetailLoan.get('fileRetailLoanPolicyDocumentId')
        const scrollDown = immRetailLoan.get('scrollDown')

        params.query = {
            ...params.query,
            newQueryProperty: 'newQueryValue',
            acceptedText,
            operationProcessId,
            documentId,
            scrollDown
        };
    }
    return APIPost({ dispatch, endpoint: 'retailLoanFormalize', params });
};

const setInterstitialValue = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    if (!immRetailLoan.get("acceptInterstitialConsentsValue")) {
        const customData = buildEventsModalInterstitial({
            etiquetaEvento: TAGGING_ACCEPT
        });
        recordLinkV2(customData);
    }
    return dispatch(simpleActions.retailLoanSetInterstitialCheck());
}

const formalizeProcess = (dataToken) => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const immProducts = immRetailLoan.get('products');
    const selectedItemId = immRetailLoan.get('purpose');
    const immSelectedItem = immProducts.find(immItem => selectedItemId === immItem.get('nid'));

    dispatch(formalizeQuery(dataToken))
        .then(() => {
            dispatch(simpleActions.retailLoanFormalizeSuccess());
            const customData = buildFormalizeRetailLoanProcess(immSelectedItem, TAGGING_PURCHASE);
            recordProcess(PROC_CONTRACT_RETAIL_LOAN, PROC_END, customData, true);
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.retailLoanFormalizeError());
            } else {
                throw response;
            }
            const checkoutStep = {
                checkout_step: [FORMALIZE_ERROR],
            }
            const customData = buildFormalizeRetailLoanProcess(immSelectedItem, TAGGING_CHECKOUT, checkoutStep);
            recordProcess(PROC_CONTRACT_RETAIL_LOAN, PROC_FAIL, customData, true);
        });
};

const formalize = () => (dispatch, getState) => {

    const callback = (dispatch, getState, dataToken) => {
        dispatch(simpleActions.retailLoanFormalize());
        dispatch(formalizeProcess(dataToken));
    };

    validateAndExecute(dispatch, getState, callback);
};

const getAsnefValidation = (currentStep) => (dispatch, getState) => {

    const immSegmented = getState().contractRetailLoan.getIn(['segmented', 'informacion'], {});
    const newRetailFlowFeature = getState().flagBasedFeatures.get(NOT_ALLOWED_NEW_RETAIL_LOAN_FLOW_COUNTRIES);
    const params = {
        query: {
            productType: immSegmented.get('tipo'),
            productSubType: immSegmented.get('subtipoPagoAniversario'),
            productStandard: immSegmented.get('erPagoAniversario')
        }
    };
    dispatch(simpleActions.retailLoanAsnef());

    return APIGet({ dispatch, endpoint: 'asnefValidation', params })
        .then(response => {
            if (response.response === payrollLoanCommon.ASNEFKO) {
                dispatch(simpleActions.retailLoanAsnefFailure());
            } else {
                dispatch(simpleActions.retailLoanAsnefSuccess({ currentStep, newRetailFlowFeature }));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.retailLoanAsnefError());
            } else {
                throw response;
            }
        });
};
const getInitParams = (initCall) => (dispatch, getState) => {
    const accounts = getState().accounts;
    const immRetailLoan = getState().contractRetailLoan;
    const selectedAccount = immRetailLoan.get('selectedAccount');
    const accountIndexes = getFilteredAccountIndexes(accounts).toJS();
    const accountId = selectedAccount ? selectedAccount : accountIndexes[0];
    const immAccount = accounts.getIn(['byId', accountId, 'iban']);
    const endOfMonth = immRetailLoan.get('paymentDaySelected') === PAYMENT_DAY_END_OF_MONTH;
    const financedCommission = immRetailLoan.get('indCapson') === amortizationTypes.YES ?
        payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA;
    const immSegmented = immRetailLoan.getIn(['segmented', 'informacion'], {});
    const immSelectedItem = getItem(immRetailLoan);
    const immProposition = immRetailLoan.get('proposition');
    const proccesTypeContract = initCall === 1 ? NEW_RETAIL_LOAN_PRECONTRACTUAL : NEW_RETAIL_LOAN_CONTRACT
    const retailInitOperationProcessId = immRetailLoan.get('retailInitOperationProcessId');

    return {
        query:
        {
            account: immAccount || 0,
            wellFinancedDenomination: immSelectedItem.get('field_cms_id'),
            amount: immSelectedItem.get('field_total_product_price'),
            calculatedOpeningCommission: formatAmount(immSegmented.get('comisionApertura'), 'es', 2),
            capitalizedOpeningCommissionIndicator: immRetailLoan.get('indCapson'),
            contractNumberAccount: 0,
            dueDate: moment(immProposition.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth: endOfMonth,
            financedCommission: financedCommission,
            firstTime: true,
            loanPurpose: immSelectedItem.get('field_commercial_text_app'),
            processType: proccesTypeContract,
            product: {
                standard: immSelectedItem.get('field_reference_standard'),
                subType: immSegmented.get('subtipo'),
                type: immSegmented.get('tipo'),
            },
            productDuration: immRetailLoan.get('selectedTerm').toString(),
            productType: retailLoanCommons.PRODUCT_TYPE,
            propositionContractNumber: immProposition.get('contractNumber'),
            propositionNumber: immProposition.get('propositionNumber', 0),
            tin: immRetailLoan.get('tin'),
            tae: formatAmount(immRetailLoan.get('tae'), 'es', 2),
            term: immRetailLoan.get('selectedTerm'),
            year: immProposition.get('propositionYear'),
            ...(initCall === 2 && { attachedEvidences: [retailInitOperationProcessId] })
        }
    }
}
const getRetailLoanINE = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const operationProcessId = immRetailLoan.get('retailInitOperationProcessId')
    APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${operationProcessId}/${NEW_RETAIL_LOAN_PRECONTRACTUAL}/documents`)
        .then(response => {
            const { base64Document, temporaryDocumentId } = response;
            dispatch(simpleActions.getRetailLoanIneDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId }));
        })
        .catch(() => {
            dispatch(simpleActions.getRetailLoanIneDocumentError());
        });
}
const getRetailLoanPolicy = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const operationProcessId = immRetailLoan.get('retailInitPolicyOperationProcessId')

    APIGet(dispatch, `${apiURLBuilder.getURL('loanContractDocuments')}/${operationProcessId}/${NEW_RETAIL_LOAN_CONTRACT}/documents`)
        .then(response => {
            const { base64Document, temporaryDocumentId } = response;
            dispatch(simpleActions.getRetailLoanPolicyDocumentSuccess({ base64: base64Document, documentId: temporaryDocumentId, operationProcessId }));
        })
        .catch(() => {
            dispatch(simpleActions.getRetailLoanPolicyDocumentError());
        });


}
const getInitRetailLoanPolicy = (initCall) => (dispatch) => {
    const params = dispatch(getInitParams(initCall));
    return APIPost({
        dispatch,
        endpoint: 'overdraftInit',
        params
    })

        .then((response) => {
            dispatch(simpleActions.contractRetailLoanInitPolicySuccess({ retailInitPolicyOperationProcessId: response.operationProcessId }));
            dispatch(getRetailLoanPolicy())
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractRetailLoanInitError());
            } else {
                throw response;
            }
        });
}
const getInitRetailLoanIne = (initCall) => (dispatch) => {
    const params = dispatch(getInitParams(initCall));
    return APIPost({
        dispatch,
        endpoint: 'overdraftInit',
        params
    })
        .then((response) => {
            dispatch(simpleActions.contractRetailLoanInitSuccess({ retailInitOperationProcessId: response.operationProcessId }));
            dispatch(getRetailLoanINE())

        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractRetailLoanInitError());
            } else {
                throw response;
            }
        });
}
const sendPreContractualInfo = (hiringDocument) => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const immSelectedItem = getItem(immRetailLoan);
    const immSegmented = immRetailLoan.getIn(['segmented', 'informacion'], {});

    const params = {
        query: {
            "producto": immSegmented.get('tipo'),
            "standard": immSelectedItem.get('field_reference_standard'),
            "subproducto": immSegmented.get('subtipo'),
            "templateCode": RETAIL_LOAN_PRECONTRACTUAL,
            "hiringDocumentRequest": hiringDocument
        }
    }

    dispatch(simpleActions.retailLoanSendPrecontractualInfoRequest());
    return APIPost({ dispatch, endpoint: 'sendPrecontractualDocumentMail', params })
        .then(() => {
            dispatch(simpleActions.retailLoanSendPrecontractualInfoSuccess())
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.retailLoanSendPrecontractualInfoFailure({ error: response.error }));
            } else {
                throw response;
            }
        });
};
const sendRetalLoanSimpleEmail = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const scrollDown = immRetailLoan.get('scrollDown')
    const acceptanceText = formatText(translationContractLoanPdfViewerINE.PDF_CHECKBOX)
    const immSelectedItem = getItem(immRetailLoan);
    const immSegmented = immRetailLoan.getIn(['segmented', 'informacion'], {});
    const operationProcessId = immRetailLoan.get('retailInitOperationProcessId')
    const documentId = immRetailLoan.get('fileRetailLoanINEDocumentId')

    const params = {
        query: {
            mailType: NEW_RETAIL_LOAN_PRECONTRACTUAL,
            documentId,
            product: {
                standard: immSelectedItem.get('field_reference_standard'),
                subType: immSegmented.get('subtipo'),
                type: immSegmented.get('tipo'),
            },
            contractNumberAccount: '0',
            operationProcessId: operationProcessId,
            acceptanceText,
            scrollDown
        }
    };
    APIPost({
        dispatch,
        endpoint: 'sendRetailSimpleEmail',
        params
    })
        .then(() => {
            dispatch(simpleActions.contractRetailEmailSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.contractRetailEmailError());
            } else {
                throw response;
            }
        });
};
const validateStep = (currentStep) => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const beforeStep = immRetailLoan.get('beforeStep');
    const agreeThirdStep = immRetailLoan.get('agreeThirdStep');
    const term = immRetailLoan.get('selectedTerm');
    const isRetailEmailSent = immRetailLoan.get('isRetailEmailSent');
    const newRetailFlowFeature = getState().flagBasedFeatures.get(NOT_ALLOWED_NEW_RETAIL_LOAN_FLOW_COUNTRIES);
    const sendSimpleEmail = immRetailLoan.get('sendSimpleEmail');
    const changeStatusSteps = immRetailLoan.get('changeStatusSteps');
    if (currentStep === WIZARD_FIRST_STEP && !!term && beforeStep === DEFAULT_BEFORE_STEP) {
        const customDataEvent = buildEventsWizardRetailLoan(
            immRetailLoan,
            TAGGING_NEXT
        );
        const customData = {
            ...customDataEvent,
            event_name: "event_success",
            action: "success",
            format: "steps",
            component: "funnel",
            element: "summary",
        };
        recordLinkV2(customData);
        dispatch(getAsnefValidation(currentStep));
    } else if (agreeThirdStep && (currentStep === WIZARD_THIRD_STEP) && newRetailFlowFeature) {
        const customData = {
            event_name: "event_success",
            action: "success",
            format: "steps",
            component: "funnel",
            element: "confirmation",
        };
        recordLinkV2(customData);
        if (newRetailFlowFeature) {
            if (changeStatusSteps) {
                dispatch(getInitRetailLoanPolicy(2));
            }
            dispatch(simpleActions.retailLoanValidateStep({ currentStep: 3, newRetailFlowFeature }));
            if (!isRetailEmailSent && sendSimpleEmail) {
                dispatch(sendRetalLoanSimpleEmail())
                dispatch(getProposition())
            }
        }

    } else if (currentStep === WIZARD_FOURTH_STEP && newRetailFlowFeature) {
        console.log('current3')

        const customData = {
            event_name: "event_success",
            action: "success",
            format: "steps",
            component: "funnel",
            element: "confirmation",
        };
        recordLinkV2(customData);
        dispatch(formalize());
    }
    else if (agreeThirdStep && (currentStep === WIZARD_THIRD_STEP) && !newRetailFlowFeature) {
        const customData = {
            event_name: "event_success",
            action: "success",
            format: "steps",
            component: "funnel",
            element: "confirmation",
        };
        recordLinkV2(customData);
        dispatch(formalize());
    } else {
        dispatch(getProposition())
            .then(() => {
                if (newRetailFlowFeature && changeStatusSteps && currentStep !== WIZARD_FIRST_STEP) {
                    dispatch(getInitRetailLoanIne(1));
                }
                if (!newRetailFlowFeature) {
                    dispatch(getHiringDocuments());
                }
            })
            .catch(() => {
                if (!newRetailFlowFeature) {
                    dispatch(getHiringDocuments());
                }
            })
        dispatch(simpleActions.retailLoanValidateStep({ currentStep, newRetailFlowFeature }));
    }
}

const getRemainingInfo = (propositionNumber, propositionYear, contractNumber, productNumber) => dispatch => {
    const params = {
        query: {
            anio: propositionYear,
            numeroPropuesta: propositionNumber
        }
    };

    const promises = [];

    const amortizationPromise = APIGet({
        dispatch,
        params,
        endpoint: 'contractEasyLoanAmortizationAmortization'
    });
    promises.push(amortizationPromise);

    const initialDataPromise = APIGet({
        dispatch,
        params,
        endpoint: 'contractEasyLoanInitialData'
    });
    promises.push(initialDataPromise);
    return Promise.all(promises).then(responses => {
        const amortizationReponse = responses[0];
        const initialDataResponse = responses[1];
        return dispatch(
            simpleActions.retailLoanPropositionInfoSuccess({
                response: {
                    propositionNumber,
                    propositionYear,
                    contractNumber,
                    lackDate: initialDataResponse.fechaFinCarencia,
                    loanDueDate: initialDataResponse.fechaVctoPrestamos,
                    chargeOffDate: amortizationReponse.fechaAmortiz,
                    productNumber
                }
            })
        );
    });
}

const getProposition = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const immSegmented = immRetailLoan.getIn(['segmented', 'informacion'], {});
    const immSelectedItem = getItem(immRetailLoan);

    const standard = immSegmented.get('erPagoAniversario');
    const productType = immSegmented.get('tipo');
    const productSubType = immSegmented.get('subtipoPagoAniversario');
    const indCapson = immRetailLoan.get('indCapson');

    const params = {
        query: {
            indCapson,
            importePpta: {
                importe: immSelectedItem.get('field_total_product_price'),
                divisa: immRetailLoan.get('currency')
            },
            plazoPpta: {
                numerodeunidades: immRetailLoan.get('selectedTerm'),
                unidaddetiempo: retailLoanCommons.TIME_UNIT
            },
            finalidadPpta: retailLoanCommons.PURPOSE,
            tipoPreciosOpera: retailLoanCommons.PRICE_TYPE,
            canalOperacion: retailLoanCommons.CHANNEL,
            estandar: {
                codigodeestandar: standard,
                subtipodeproducto: {
                    subtipodeproducto: productSubType,
                    tipodeproducto: {
                        tipodeproducto: productType
                    }
                }
            }
        }
    };

    dispatch(simpleActions.retailLoanPropositionInfo());
    return APIPost({ dispatch, endpoint: 'contractEasyLoanPropositionNumber', params })
        .then(response => {
            const propositionNumber = get(response, 'propuesta.numerodepropuesta');
            const propositionYear = get(response, 'propuesta.anio');
            const contractNumber = get(response, 'contrato.numerodecontrato');
            const productNumber = get(response, 'contrato.producto');
            return dispatch(getRemainingInfo(propositionNumber, propositionYear, contractNumber, productNumber));
        })
        .catch(() => {
            if (!!response.error) {
                dispatch(simpleActions.retailLoanPropositionInfoError({ error: response2.error }));
            } else {
                throw response2;
            }
        });
};

const onDownloadDocument = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const immSegmented = immRetailLoan.getIn(['segmented', 'informacion'], {});
    const accounts = getState().accounts;

    const selectedAccount = immRetailLoan.get('selectedAccount');
    const immSelectedItem = getItem(immRetailLoan);
    const immProposition = immRetailLoan.get('proposition');

    const isFetchingZip = immRetailLoan.get('isFetchingZip');
    const financedCommission = immRetailLoan.get('indCapson') === amortizationTypes.YES ? payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA;

    if (!isFetchingZip) {
        const tinRaw = parseSpanishNumberToFloat(immRetailLoan.get('tin'));

        const params = {
            header: {
                responseType: 'arraybuffer'
            },
            query: {
                amount: formatAmount(immSelectedItem.get('field_total_product_price'), 'es', 2),
                calculatedOpeningCommission: formatAmount(immSegmented.get('comisionApertura'), 'es', 2),
                capitalizedOpeningCommissionIndicator: immRetailLoan.get('indCapson'),
                clientAccountCode: accounts.getIn(['byId', selectedAccount, 'iban']),
                dueDate: moment(immProposition.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
                endOfMonth: false,
                financedCommission,
                firstTime: true,
                loanPurpose: immSelectedItem.get('field_commercial_text_app'),
                productDuration: immRetailLoan.get('selectedTerm').toString(),
                propositionContractNumber: immProposition.get('contractNumber'),
                propositionNumber: immProposition.get('propositionNumber').toString(),
                tae: formatAmount(immRetailLoan.get('tae'), 'es', 2),
                tin: formatNumber(tinRaw.toFixed(2)),
                year: immProposition.get('propositionYear'),
                productType: retailLoanCommons.PRODUCT_TYPE,
                wellFinancedDenomination: immSelectedItem.get('title')
            }
        };
        dispatch(simpleActions.retailLoanDownloadZipDocument());
        APIPost({ dispatch, endpoint: 'loanHiringDocumentsZip', params })
            .then(response => {
                dispatch(simpleActions.retailLoanDownloadZipDocumentSuccess());
                download(response.xhr.response, 'documentosPrestamoCompra.zip', 'application/zip');
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.retailLoanDownloadZipDocumentError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    }
};

const onDownloadDocumentTermCondition = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const document = immRetailLoan.get('documentsTermConditions');
    download(document, 'Términos_y_Condiciones', 'application/pdf');
};

const onPrintDocument = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const documents = immRetailLoan.get('documents') != null ? immRetailLoan.get('documents') : immRetailLoan.get('documentsTermConditions');
    const data = [new Uint8Array(documents)];

    const blobObject = new Blob(data, { type: 'application/pdf' });

    if (BrowserUtils.browserIsIE()) {
        window.navigator.msSaveOrOpenBlob(blobObject);
    } else {
        const blobURL = window.URL.createObjectURL(blobObject);
        const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
            'resizable,screenX=50,screenY=50,width=850,height=1050';
        const printWindow = window.open(blobURL, '', winparams);

        if (printWindow) {
            printWindow.print();
        }
    }
};

const downloanRetailLoanContractDocument = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const immAccounts = getState().accounts;

    const selectedAccount = immRetailLoan.get('selectedAccount');
    const immSelectedItem = getItem(immRetailLoan);
    const immProposition = immRetailLoan.get('proposition');

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            year: immProposition.get('propositionYear'),
            clientAccountCode: immAccounts.getIn(['byId', selectedAccount, 'iban']),
            productDuration: immRetailLoan.get('selectedTerm').toString(),
            dueDate: moment(immProposition.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth: false,
            loanPurpose: immSelectedItem.get('field_commercial_text_app'),
            amount: formatAmount(immSelectedItem.get('field_total_product_price'), 'es', 2),
            capitalizedOpeningCommissionIndicator: immRetailLoan.get('indCapson'),
            propositionContractNumber: immProposition.get('contractNumber'),
            propositionNumber: immProposition.get('propositionNumber', 0).toString(),
            firstTime: true,
            tae: formatAmount(immRetailLoan.get('tae'), 'es', 2),
            productType: retailLoanCommons.PRODUCT_TYPE,
        }
    };

    dispatch(simpleActions.retailLoanDownloadPrintDocument());
    APIPost({ dispatch, endpoint: 'requestEasyLoanContractDocument', params }).then(response => {
        const content = get(response, 'xhr.response');
        downLoadDocumentInOtherPage(content);
        dispatch(simpleActions.retailLoanDownloadPrintDocumentSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.retailLoanDownloadPrintDocumentError());
        });
};

const downloadINEDocument = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const immSelectedItem = getItem(immRetailLoan);
    const immProposition = immRetailLoan.get('proposition');
    const immSegmented = immRetailLoan.getIn(['segmented', 'informacion'], {});

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            amount: formatAmount(immSelectedItem.get('field_total_product_price'), 'es', 2),
            calculatedOpeningCommission: formatAmount(immSegmented.get('comisionApertura'), 'es', 2),
            dueDate: moment(immProposition.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
            endOfMonth: false,
            financedCommission: immRetailLoan.get('indCapson') === amortizationTypes.YES ?
                payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA,
            firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
            productDuration: immRetailLoan.get('selectedTerm').toString(),
            productType: retailLoanCommons.PRODUCT_TYPE,
            propositionContractNumber: immRetailLoan.get('contractNumber'),
            propositionNumber: immProposition.get('propositionNumber').toString(),
            tae: formatAmount(immRetailLoan.get('tae'), 'es', 2),
            tin: formatAmount(immRetailLoan.get('tin')),
            wellFinancedDenomination: immSelectedItem.get('title'),
            year: immProposition.get('propositionYear'),
        }
    };

    dispatch(simpleActions.retailLoanDownloadPrintDocument());
    APIPost({ dispatch, endpoint: 'contractEasyLoanINEDocument', params }).then(response => {
        const content = get(response, 'xhr.response');
        downLoadDocumentInOtherPage(content);
        dispatch(simpleActions.retailLoanDownloadPrintDocumentSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.retailLoanDownloadPrintDocumentError());
        });
};

const downloadPreContractDocument = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const immSegmented = immRetailLoan.getIn(['segmented', 'informacion'], {});
    const immSelectedItem = getItem(immRetailLoan);
    const type = immSegmented.get('tipo');
    const subType = immSegmented.get('subtipoPagoAniversario');
    const standar = immSelectedItem.get('field_reference_standard');
    const params = {
        query: {
            estandar: standar,
            subtipo: subType,
            tipo: type,
            idioma: retailLoanCommons.LANGUAGE_ID
        }
    };

    dispatch(simpleActions.retailLoanDownloadPrintDocument());
    APIGet({ dispatch, endpoint: 'requestPreContractActive', params }).then(response => {
        const pdfUrl = get(response, 'response[0].url');
        if (!!pdfUrl) {
            window.open(pdfUrl);
        }
        dispatch(simpleActions.retailLoanDownloadPrintDocumentSuccess());
    })
        .catch(() => {
            dispatch(simpleActions.retailLoanDownloadPrintDocumentError());
        });
};

const getHiringDocuments = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const immSegmented = immRetailLoan.getIn(['segmented', 'informacion'], {});
    const accounts = getState().accounts;

    const selectedAccount = immRetailLoan.get('selectedAccount');
    const immSelectedItem = getItem(immRetailLoan);
    const immProposition = immRetailLoan.get('proposition');
    const tinRaw = parseSpanishNumberToFloat(immRetailLoan.get('tin'));

    const hiringDocument = {
        amount: formatAmount(immSelectedItem.get('field_total_product_price'), 'es', 2),
        calculatedOpeningCommission: formatAmount(immSegmented.get('comisionApertura'), 'es', 2),
        capitalizedOpeningCommissionIndicator: immRetailLoan.get('indCapson'),
        clientAccountCode: accounts.getIn(['byId', selectedAccount, 'iban']),
        dueDate: moment(immProposition.get('loanDueDate')).format(DATE_FORMAT_WITH_SLASHES),
        endOfMonth: false,
        financedCommission: immRetailLoan.get('indCapson') === amortizationTypes.YES ?
            payrollLoanCommon.FINANCIADA : payrollLoanCommon.NO_FINANCIADA,
        firstTime: true, //fixed value. The user hasn't contracted the loan yet in this step. So we show a template.
        loanPurpose: immSelectedItem.get('field_commercial_text_app'),
        productDuration: immRetailLoan.get('selectedTerm').toString(),
        propositionContractNumber: immProposition.get('contractNumber'),
        propositionNumber: immProposition.get('propositionNumber', 0).toString(),
        tae: formatAmount(immRetailLoan.get('tae'), 'es', 2),
        tin: formatNumber(tinRaw.toFixed(2)),
        year: immProposition.get('propositionYear'),
        productType: retailLoanCommons.PRODUCT_TYPE,
        wellFinancedDenomination: immSelectedItem.get('title')
    };

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: hiringDocument
    };

    dispatch(simpleActions.retailLoanHiringDocuments());
    APIPost({ dispatch, endpoint: 'loanHiringDocuments', params })
        .then(response => {
            dispatch(simpleActions.retailLoanHiringDocumentsSuccess({ documents: response.xhr.response }));
            const isSendPreContractualInfoEnabled = getState().flagBasedFeatures.get(PRE_CONTRACTUAL_RETAIL_LOAN_MAIL);
            if (isSendPreContractualInfoEnabled) {
                dispatch(sendPreContractualInfo(hiringDocument));
            }

        })
        .catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.retailLoanHiringDocumentsError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const getTermConditionDocuments = (item) => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const isFetching = immRetailLoan.get('isFetchingDocumentsTermConditions');
    const immItem = item || getItem(immRetailLoan);
    const provider = immItem && immItem.getIn(['field_retail_provider', 'abbreviation']);

    const params = {
        header: {
            responseType: 'arraybuffer'
        },
        query: {
            provider
        }
    };

    if (!isFetching) {
        dispatch(simpleActions.retailLoanTermCondition());
        APIPost({ dispatch, endpoint: 'loanTermConditionDocuments', params })
            .then(response => {
                dispatch(simpleActions.retailLoanTermConditionSuccess({ documentsTermConditions: response.xhr.response }));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(simpleActions.retailLoanTermConditionError({ error: response.error }));
                } else {
                    throw response;
                }
            });
    }
};

const retailLoanSetAccount = ({accountId}) => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const proposition = immRetailLoan.get('proposition');
    const agreeThirdStep = immRetailLoan.get('agreeThirdStep');
    const previousAccountId = immRetailLoan.get('selectedAccount');

    dispatch(simpleActions.retailLoanSetAccount({ accountId }));

    if (proposition.get('success') && agreeThirdStep && previousAccountId && previousAccountId !== accountId) {
        dispatch(onAccountchange(accountId));
    }
    
}

const onAccountchange = (accountId) => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const newRetailFlowFeature = getState().flagBasedFeatures.get(
        NOT_ALLOWED_NEW_RETAIL_LOAN_FLOW_COUNTRIES
    );
    if (newRetailFlowFeature) {
        dispatch(getProposition()).then(() => {
            dispatch(getInitRetailLoanPolicy(2));
        });         
        dispatch(
            simpleActions.retailLoanValidateStep({
                currentStep: 3,
                newRetailFlowFeature,
            })
        );
    }
};

const sendEmailModifyConsent = consent => (dispatch) => {
    const consentId = consent.consentCellId;
    return APIPost(dispatch, apiURLBuilder.getURL('loanRetailCompositeEmailConsent', { consentId }));
}

const getConsentStatus = (successCallback = () => { }, errorCallback = () => { }) => (dispatch) => {
    dispatch(simpleActions.retailLoanConsents());

    const { ACCEPTED, PENDING, NOT_ACCEPTED } = RETAIL_LOAN_CONSENTS_STATUS;
    const { INTERSTITIAL_CONSENT_ID, AMAZON_CONSENT_ID } = RETAIL_LOAN_CONSENTS_ID;

    const params = {
        query: {
            "placementId": RETAIL_LOAN_PLACEMENT_ID,
            "status": [ACCEPTED, PENDING, NOT_ACCEPTED]
        }
    }

    return APIGet({ dispatch, endpoint: "consents", params })
        .then((response) => {
            const { consents } = response;
            const interstitialConsent = consents && consents.find(consent => consent.consentCell.id === INTERSTITIAL_CONSENT_ID);
            const amazonConsent = consents && consents.find(consent => consent.consentCell.id === AMAZON_CONSENT_ID);

            if (interstitialConsent) {
                dispatch(simpleActions.retailLoanConsentsSuccess(interstitialConsent));
            }
            if (amazonConsent) {
                dispatch(simpleActions.retailLoanAmazonConsentsSuccess(amazonConsent));
            }
            if (successCallback) {
                successCallback(consents);
            }
            if (!consents.length) {
                throw response;
            }
        })
        .catch((response) => {
            const message = !!response.text ? response.text : "";
            dispatch(simpleActions.retailLoanConsentsError({ error: message }));
            if (errorCallback) {
                errorCallback(message);
            }
        })
};

const getInfoDestinationAccount = () => (dispatch, getState) => {
    const immRetailLoan = getState().contractRetailLoan;
    const immItem = getItem(immRetailLoan);
    const provider = immItem && immItem.getIn(['field_retail_provider', 'abbreviation']);

    const params = {
        query: {
            provider
        }
    };

    dispatch(simpleActions.retailLoanDestinationAccount());
    APIGet({ dispatch, endpoint: 'retailLoanDestinationAccount', params })
        .then(destination => {
            const response = {
                ...destination,
                provider
            }

            dispatch(simpleActions.retailLoanDestinationAccountSuccess({ response }))
        }).catch(response => {
            if (!!response.error) {
                dispatch(simpleActions.retailLoanDestinationAccountError({ error: response.error }));
            } else {
                throw response;
            }
        });
};

const updateUserConsent = consents => dispatch => {
    dispatch(simpleActions.retailLoanConsentUpdate());

    const { ACCEPTED, PENDING } = RETAIL_LOAN_CONSENTS_STATUS;
    const { INTERSTITIAL_CONSENT_ID, AMAZON_CONSENT_ID } = RETAIL_LOAN_CONSENTS_ID;
    const interstitialConsent = consents && consents.find(consent => consent.consentCellId === INTERSTITIAL_CONSENT_ID);
    const interstitialStatus = interstitialConsent && interstitialConsent.status;
    const amazonConsent = consents && consents.find(consent => consent.consentCellId === AMAZON_CONSENT_ID);
    const amazonStatus = amazonConsent && amazonConsent.status;

    if (interstitialStatus === PENDING && amazonStatus === PENDING) {
        return;
    }
    const params = {
        query: {
            newCustomer: false,
            placementId: RETAIL_LOAN_PLACEMENT_ID,
            consents
        }
    }

    return APIPost({ dispatch, endpoint: "consents", params })
        .then(() => {
            dispatch(simpleActions.retailLoanConsentUpdateSuccess({ interstitialStatus, amazonStatus }));
            if (interstitialStatus === ACCEPTED) {
                dispatch(sendEmailModifyConsent(interstitialConsent));
            }
            if (amazonStatus === ACCEPTED) {
                dispatch(sendEmailModifyConsent(amazonConsent));
            }
        })
        .catch((response) => {
            const message = !!response.text ? response.text : "";
            dispatch(simpleActions.retailLoanConsentUpdateError({ error: message }));
        })
}

const requestAds = () => (dispatch) => {
    const idToFetch = "B.8.2.5";

    const requestData = {
        header: {
            version: 2,
        },
        query: {
            channel: COMMERCIAL_ADS_CHANNEL,
            lang: getLanguage().toLowerCase(),
            locations: [idToFetch],
            includeDuplicates: true,
        },
    };



    return APIPost(dispatch, apiURLBuilder.getURL("requestAds"), requestData)
        .then((response) => {
            dispatch(
                simpleActions.retailLoanCommercialProductsSuccess(response)
            );
        })
        .catch(() => {});
};


module.exports = {
    downloadPreContractDocument,
    downloadINEDocument,
    downloanRetailLoanContractDocument,
    formalize,
    getAsnefValidation,
    getConsentStatus,
    updateUserConsent,
    getHiringDocuments,
    retailLoanSetAccount,
    getInfoProducts,
    getProposition,
    getTermConditionDocuments,
    getTae,
    getInfoDestinationAccount,
    onDownloadDocument,
    onDownloadDocumentTermCondition,
    onPrintDocument,
    sendPreContractualInfo,
    sendEmailModifyConsent,
    setTerm,
    setInterstitialValue,
    simpleActions,
    validateStep,
    checkReadDocument,
    checkCheckedDocument,
    requestAds,
};
